$(document).ready(function() {
//     $('ul.site-nav li.site-nav--has-dropdown > a').removeAttr('href');
// $('ul.site-nav li.site-nav--has-dropdown > a').attr('role', 'button');
// $('ul.site-nav li.site-nav--has-dropdown button').attr('aria-expanded', 'false');
    // Handle click events on elements with the class "site-nav--has-dropdown"
    $("li.site-nav--has-dropdown").click(function() {
      const $dropdown = $(this).find(".site-nav__link--has-dropdown"); // Only select the first occurrence
    
      if ($dropdown.attr("aria-expanded") === "false") {
        // Close other dropdowns first
        $("li.site-nav--has-dropdown > .site-nav__link--has-dropdown").attr("aria-expanded", "false");
        $("li.site-nav--has-dropdown").removeClass("active");
        
        // Open the clicked dropdown
        $dropdown.attr("aria-expanded", "true");
        $(this).addClass("active");
        
        // Add your code to display the dropdown menu as needed here
      } else {
        // Close the clicked dropdown
        $dropdown.attr("aria-expanded", "false");
        $(this).removeClass("active");
        
        // Add your code to hide the dropdown menu as needed here
      }
    });
});
  
    // Handle focus events for VoiceOver
    $(document).on('focusin', function(event) {
      // Check if the focus is outside of elements with class "site-nav--has-dropdown"
      if ($(event.target).closest(".site-nav--has-dropdown").length === 0) {
        // Close all dropdowns by setting their "aria-expanded" attribute to "false"
        $("li.site-nav--has-dropdown > .site-nav__link--has-dropdown").attr("aria-expanded", "false");
        $("li.site-nav--has-dropdown").removeClass("active");
        
        // Add your code to hide the dropdown menu as needed here
      }
    });













    $(document).ready(function() {
      $('.site-nav--has-dropdown>a').each(function() {
          var $a = $(this);
          var $button = $('<button></button>')
              .text($a.text())
              .addClass($a.attr('class'))
              .attr('aria-expanded', $a.attr('aria-expanded'))
              .attr('tabindex', $a.attr('tabindex'));
          $a.replaceWith($button);
      });
  });
  




// $(document).ready(function() {
//     // Disable the hover behavior by removing the event listeners if they exist
//     $('.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown.site-nav--is-megamenu').off('mouseenter mouseleave');

//     // Add click event listener
//     $('li.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown.site-nav--is-megamenu button').on('click', function() {
//         var $dropdown = $(this).siblings('.site-nav__dropdown.megamenu');
//         var isExpanded = $(this).attr('aria-expanded') === 'true';
//         $('.site-nav__dropdown.megamenu').slideUp(); // Close other open menus
//         $('li.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown.site-nav--is-megamenu button').attr('aria-expanded', 'false'); // Set all buttons to collapsed
//         if (!isExpanded) {
//             $dropdown.slideDown(); // Open the clicked menu
//             $(this).attr('aria-expanded', 'true'); // Set the clicked button to expanded
//         }
//     });

//     // Optional: Close the menu if clicked outside
//     $(document).on('click', function(event) {
//         if (!$(event.target).closest('li.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown.site-nav--is-megamenu').length) {
//             $('.site-nav__dropdown.megamenu').slideUp();
//             $('li.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown.site-nav--is-megamenu button').attr('aria-expanded', 'false');
//         }
//     });

//     // Handle keyboard interactions
//     $('li.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown.site-nav--is-megamenu button').on('keydown', function(event) {
//         if (event.key === 'Enter' || event.key === ' ') {
//             event.preventDefault();
//             $(this).click(); // Trigger the click event
//         }
//     });
// });


// $(document).ready(function() {
//     $('button.site-nav__link.site-nav__link--underline.site-nav__link--has-dropdown').click(function() {
//         $(this).toggleClass('activeopen');
//     });
// });



$(document).on('keydown', function(e) {
  if (e.key === 'Escape') {
      $('#Skip_Navigation .site-nav--has-dropdown').removeClass('active');
      $('#Skip_Navigation .site-nav--has-dropdown .site-nav__link').attr('aria-expanded', 'false');
  }
})